import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderUserChangeModal = (data) => openPopupHelper({ popupName: popupNames.MOBILE_USER_CHANGE_MODAL, data });
